import React, { FunctionComponent } from 'react';
import University from '../../../../networking/models/University';
import UniversityCard from './UniversityCard';

interface Props {
    universities: University[];
    onUniversityClick: (university: University) => void;
    onUniversityDeleteClick: (university: University) => void;
}

const UniversityList: FunctionComponent<Props> = ({ universities, onUniversityClick, onUniversityDeleteClick }) => {

    return (
        <div className={'university-list'}>
            { universities.map(university => (
                <UniversityCard
                    university={university}
                    onClick={onUniversityClick}
                    onDeleteClick={onUniversityDeleteClick}
                    key={university.id} />
            )) }
        </div>
    );
};

export default UniversityList;
